module.exports = __webpack_public_path__ + "static/media/connect_prac.7617cf34.svg";